import { graphql } from 'react-apollo'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ match, staticContext }) => {
  const objectId = match.params.id

  return {
    errorPolicy: 'ignore',
    variables: { objectId },
  }
}

export const mapDataToProps = ({
  data: { error, loading, productByObjectId },
  ownProps: { match },
}) => {
  if (error) {
    return { error }
  }

  if (loading) {
    return { loading }
  }

  if (!productByObjectId) {
    const redirectPath = match.params.retailer
      ? `/products/retailer/${match.params.retailer}`
      : '/products'
    return { redirect: redirectPath }
  }

  const { product, related } = productByObjectId
  return {
    product,
    related,
    categoryPath: product.primaryCategoryPath,
    subcategoryDepth: 0,
  }
}

const withProduct = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withProduct
